import type { RiskBand, RiskBandSet } from '@gcv/shared';

// Matches the pinned version id, not the logical risk_band_id. Falls back to the active set, which
// is all useRiskBandSets returns — a superseded pin is unfetchable.
export const getResultRiskBands = (
  bandSets: RiskBandSet[] | undefined,
  riskBandSetId?: string
): RiskBand[] => {
  const sets = bandSets ?? [];
  const set = sets.find((candidate) => candidate.id === riskBandSetId) ?? sets[0];

  return [...(set?.bands ?? [])].sort((a, b) => a.min - b.min);
};
